import React, { ReactNode } from 'react';
import Splashscreen from 'assets/images/auth-page-splash-screen.png';
import { Box, Flex, Image } from '@televet/kibble-ui';

interface IProps {
  children: ReactNode;
}

const DefaultPublic = ({ children }: IProps): JSX.Element => {
  return (
    <Box as="main" h="100vh" w="100%" bg="">
      <Flex alignItems="center" justifyContent="center" height="100%" padding={[0, 20]}>
        <Flex
          direction={['column', 'row']}
          bg="background.default"
          border="1px"
          borderColor="border.default"
          width="100%"
          height="100%"
          gap={[10, 0]}
          borderRadius="8px"
        >
          <Box flexBasis={['100%', '40%']} height="100%" position="relative">
            <Image src={Splashscreen} alt="Otto" w="100%" h="100%" objectFit="cover" objectPosition="50% 30%" />
          </Box>
          <Flex flexBasis={['100%', '60%']} alignItems={['flex-start', 'center']} justifyContent="center">
            {children}
          </Flex>
        </Flex>
      </Flex>
    </Box>
  );
};

export default DefaultPublic;
